import React, { Component } from 'react';
import { connect } from "react-redux";

//import {} from "reducers/wallet/walletActions";

import PartyTypeahead from "components/PartyTypeahead/PartyTypeahead";

import PasswordModal from "components/PasswordModal/PasswordModal";

import { Row, Col, Well, FormGroup, ControlLabel, Button } from "react-bootstrap";

import NumberFormat from 'react-number-format';

import { fetchAccountBalance, saveTransfer } from 'reducers/wallet/walletActions';

import { formatToDecimal, roundNumber } from "utils/Number/NumberUtils"

import { showWarningMessage, showSuccessfulMessage } from "reducers/application/applicationActions";

import classNames from 'classnames';

class WalletTransfer extends Component {

    constructor(props) {
        super(props);
        this.initialState();
    }

    initialState() {
        this.state = {
            party: null,
            amount: 0,
            targetPartyError: null,
            amountError: null,
            showPasswordModal: false,
            passwordModalLoading: false
        };
    }

    componentWillMount() {
        this.props.fetchAccountBalance();
    }

    handlePartyChange(party) {
        if (party != null) {
            this.cleanTargetPartyError();
        }
        this.setState({ party: party });
    }

    valid = () => {
        if (this.state.party == null) {
            this.props.showWarningMessage("Por favor busque un destinatario");
            this.setState({ targetPartyError: "Busque un destinatario" });
            return false;
        }

        if (this.state.amount == null || this.state.amount == undefined || this.state.amount <= 0) {
            this.props.showWarningMessage("Por favor ingrese un monto válido a transferir");
            this.setState({ amountError: "Ingrese un monto válido a transferir" });
            return false;
        }

        if (this.state.amount > this.props.balance.amount) {
            this.props.showWarningMessage("El monto a transferir no puede ser mayor al saldo disponible");
            return false;
        }
        return true;
    }

    cleanTargetPartyError() {
        this.setState({ targetPartyError: null });
    }

    cleanAmountError() {
        this.setState({ amountError: null });
    }

    showPasswordModal = () => {
        if (this.valid()) {
            this.setState({ showPasswordModal: true })
        }
    }

    transfer(password) {
        this.setState({ passwordModalLoading: true });

        let promise = new Promise((resolve, reject) => {
            let transferDto = {
                targetPartyId: this.state.party.id,
                amount: this.state.amount,
                password: password
            }
            this.props.saveTransfer(transferDto, resolve, reject);
        });
        promise.then(() => {
            this.props.showSuccessfulMessage("Transferencia realizada correctamente");
            this.partyTypeahead.clearText();
            this.props.fetchAccountBalance();
            this.setState({
                party: null,
                amount: 0,
                targetPartyError: null,
                amountError: null,
                showPasswordModal: false,
                passwordModalLoading: false
            });
        }, () => {
            this.setState({
                passwordModalLoading: false
            });
        });
    }

    render() {
        const { targetPartyError, amountError } = this.state;
        const targetPartyClass = classNames('form-group',
            { 'has-error': targetPartyError != null }
        );
        const amountClass = classNames('form-group',
            { 'has-error': amountError != null }
        );
        return (
            <div>
                <div className="d-flex justify-content-center align-items-center">
                    <Well bsSize="large" bsClass="wallet_transfer__card">

                        <div className="wallet-transfer__balance_cont">
                            {this.props.balance != null &&
                                <div className="wallet-transfer__balance">
                                    <b>Saldo Disponible: </b><span><b>{formatToDecimal(roundNumber(this.props.balance.amount))}$</b></span>
                                </div>
                            }
                        </div>

                        <div className={targetPartyClass}>
                            <ControlLabel><b>Destinatario</b></ControlLabel>
                            <PartyTypeahead
                                onRef={ref => (this.partyTypeahead = ref)}
                                selection={this.state.party}
                                handleChange={(party) => this.handlePartyChange(party)} />
                            <span className="help-block">{targetPartyError}</span>
                        </div>

                        <div className={amountClass}>
                            <ControlLabel><b>Monto a transferir</b></ControlLabel> <br />
                            <NumberFormat
                                className="form-control input-sm form-control-sm wallet-transfer__amount"
                                value={this.state.amount}
                                decimalScale={2}
                                thousandSeparator={true}
                                suffix={'$'}
                                onValueChange={(values) => {
                                    const { formattedValue, value } = values;
                                    // formattedValue = $2,223
                                    // value ie, 2223
                                    if (value != null && value != undefined && value > 0) {
                                        this.cleanAmountError();
                                    }
                                    this.setState({ amount: value })
                                }} />
                            <span className="help-block">{amountError}</span>
                        </div>

                        <FormGroup>
                            <Button className="bg-light-secondary float-right" onClick={this.showPasswordModal}>Transferir</Button>
                        </FormGroup>
                    </Well>
                </div>

                <PasswordModal
                    show={this.state.showPasswordModal}
                    loading={this.state.passwordModalLoading}
                    onHide={() => this.setState({ showPasswordModal: false })}
                    save={(password) => this.transfer(password)}
                    buttonLabel="Confirmar Transferencia"
                />

            </div>
        )
    }
}

const mapStateToProps = state => ({
    balance: state.account.balance
});

export default connect(mapStateToProps,
    {
        fetchAccountBalance,
        saveTransfer,
        showWarningMessage,
        showSuccessfulMessage
    })(WalletTransfer);



// WEBPACK FOOTER //
// ./src/components/WalletTransfer/WalletTransfer.jsx